import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-3/4 m-auto" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"relative mb-5\"><div class=\"absolute inset-0 flex items-center\" aria-hidden=\"true\"><div class=\"w-full border-t border-gray-300\"></div></div><div class=\"relative flex justify-center\"><span class=\"bg-white px-2 text-sm text-gray-500\">Calendar</span></div></div>", 1)

import { ref, watch, onMounted } from "vue";
import { addDays, subDays, format as dateFormat } from "date-fns";
import "@fullcalendar/core/vdom"; // solves problem with Vite

import FullCalendar, { CalendarOptions } from "@fullcalendar/vue3";

import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";

import { max as _max, min as _min } from "lodash";

import { getPublicBookingCalendarEvents } from "@/lib/bookings";
import { CalendarEvent } from "@/lib/calendar";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingCalendar',
  props: ["today"],
  setup(__props) {

const props = __props;


const calendar = ref(null) as any;

let currentEvents: Array<CalendarEvent> = []; //as EventApi[];

const handleDateClick = (arg: DateClickArg) => {
  alert("date click! " + arg);
};
// const handleEvents = (events: EventApi[]) => {
//   currentEvents = events;
// };

const calendarOptions: CalendarOptions = {
  plugins: [dayGridPlugin, interactionPlugin],
  // today: props.today,
  initialView: "dayGridMonth",
  // lazyFetching: false,
  dateClick: handleDateClick,
  events: async () => {
    // console.log("events call")
    const currDate = calendar.value.getApi().getDate(); // usually the 1st of the greyed area so last month
    const currMonth = dateFormat(currDate, "yyyy-MM");
    const checkin = dateFormat(subDays(currDate, 30), "yyyy-MM-01");
    const checkout = dateFormat(addDays(currDate, 90), "yyyy-MM-dd");
    // check last even to avoid querying too much
    const latestEventMonth = _max(currentEvents.map((e) => e.end))?.substring(0, 7);
    const earliestEventMonth = _min(currentEvents.map((e) => e.start))?.substring(0, 7);
    // console.log(currMonth, earliestEventMonth, latestEventMonth, currentEvents);
    if (!earliestEventMonth || !latestEventMonth) {
      // continue
    } else if (currMonth < latestEventMonth && currMonth > earliestEventMonth) {
      return currentEvents;
    }
    // console.log("Querying events"); //,calendar.value.getApi().getDate(),{ checkin, checkout });
    const calendarEvents = await getPublicBookingCalendarEvents({ checkin, checkout });
    currentEvents = calendarEvents;
    return calendarEvents;
  },
};

watch(props, (nV, oV) => {
  //  calendarOptions.date = props.today;
  // console.log("watcher", props.today);
  calendar.value.getApi().gotoDate(props.today);
  calendar.value.getApi().refetchEvents();
});

onMounted(async () => {
  // fill calendar for this month;
  currentEvents = await getPublicBookingCalendarEvents({
    checkin: dateFormat(new Date(), "yyyy-MM-01"),
    checkout: dateFormat(new Date(), "yyyy-MM-10"),
  });
  calendar.value.getApi().refetchEvents();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(FullCalendar), {
      ref_key: "calendar",
      ref: calendar,
      options: calendarOptions
    }, null, 512)
  ]))
}
}

})